import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { ProductImage } from './ProductImage';
import { PRODUCT_NAME, PILLARS } from './constants';
export function FinalCTA() {
  return <section className="bg-brand-navy text-white px-4 py-7 border-t-4 border-brand-orange" data-id="element-48" data-mp="c8c035kk8fdk">
      <div className="max-w-3xl mx-auto text-center" data-id="element-49" data-mp="84dymo7rishc">
        <h2 className="font-display text-2xl sm:text-3xl text-white mb-2" data-id="element-50" data-mp="m4ow4a3kv5bh">
          One Last Question
        </h2>

        <p className="text-sm sm:text-base text-white/85 font-medium leading-snug" data-id="element-51" data-mp="h6nc9mybv1yy">
          How many times have you finished one PE lesson and thought:
        </p>
        <p className="font-heading font-bold text-base sm:text-lg text-brand-orange leading-snug mb-2" data-id="element-52" data-mp="qvoqb7lbb9aa">
          “What am I teaching next?”
        </p>
        <p className="text-sm sm:text-base text-white/85 font-medium leading-snug mb-1" data-id="element-53" data-mp="14w7xkchyebbe">
          You can keep searching for activities, rebuilding lessons and adapting
          old plans every week.
        </p>
        <p className="text-sm sm:text-base text-white/85 font-medium leading-snug mb-1" data-id="element-54" data-mp="2c67tutwgjub5">
          Or you can open one organized system.
        </p>
        <p className="font-heading font-semibold text-sm sm:text-base text-white leading-snug mb-3" data-id="element-55" data-mp="2m344b55x2qic">
          Choose the lesson. Review the setup. Prepare the equipment. Adapt if
          necessary. Teach.
        </p>

        <ProductImage className="max-w-[220px] mb-3" data-id="element-56" data-mp="2v2hddwq4pd2j" />

        <div className="bg-white/10 border border-white/20 rounded-xl p-3 mb-3" data-id="element-57" data-mp="2v1obpa611dr9">
          <p className="font-display text-2xl sm:text-3xl text-white leading-none" data-id="element-58" data-mp="300iuwd7wp4bw">
            🏃 {PRODUCT_NAME}
          </p>
          <p className="font-heading font-semibold text-xs sm:text-sm text-brand-orange uppercase tracking-widest mt-1" data-id="element-59" data-mp="39s5f2z282dqs">
            The Complete Ready-to-Teach System
          </p>
          <p className="text-[11px] sm:text-xs text-white/80 font-medium mt-0.5" data-id="element-60" data-mp="3epoqzsbg6efk">
            {PILLARS}
          </p>
          <p className="font-heading font-extrabold text-sm text-white uppercase tracking-wide mt-2" data-id="element-61" data-mp="1jo3i5j6gg94k">
            🔥 Get the complete system today
          </p>
        </div>

        <CTAButton className="max-w-md mx-auto" data-id="element-62" data-mp="1en5symn12etk">
          🏃 YES! I WANT {PRODUCT_NAME}
        </CTAButton>

        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1 mt-2.5 text-xs sm:text-sm font-heading font-bold text-white/90" data-id="element-63" data-mp="1siht59jycxhv">
          <span className="inline-flex items-center gap-1.5" data-id="element-64" data-mp="22drurw6fv2v4">
            <ZapIcon className="w-4 h-4 text-brand-orange" aria-hidden="true" data-id="element-65" data-mp="1xg06dc505yvo" />
            Immediate Access • Digital Delivery
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-66" data-mp="2be7wb03mfzxc">
            <ShieldCheckIcon className="w-4 h-4 text-brand-green" aria-hidden="true" data-id="element-67" data-mp="27decahtav59q" />
            🛡️ 14-Day Money-Back Guarantee
          </span>
        </div>
      </div>
    </section>;
}